import { render } from "./Performance.vue?vue&type=template&id=f373c36c&scoped=true&lang=pug"
import script from "./Performance.vue?vue&type=script&lang=js"
export * from "./Performance.vue?vue&type=script&lang=js"

import "./Performance.vue?vue&type=style&index=0&id=f373c36c&lang=scss&scoped=true"
import "./Performance.vue?vue&type=style&index=1&id=f373c36c&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f373c36c"]])

export default __exports__